import React, { useState, useEffect, useRef } from "react";
import { useArtist } from "../../context/ArtistContext";

const ArtistSelector = () => {
  const { selectedArtist, userArtists, setSelectedArtist } = useArtist();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelectArtist = (artist) => {
    setSelectedArtist(artist);
    setIsOpen(false);
  };

  if (!userArtists || userArtists.length === 0) {
    return null;
  }

  // Display logic:
  // - If only one artist: show artist's stage_name (no dropdown needed, but show for consistency)
  // - If multiple artists: show "All" when selectedArtist is null, or artist stage_name when selected
  const displayText = () => {
    if (userArtists.length === 1) {
      return userArtists[0].stage_name;
    }
    // Multiple artists
    if (selectedArtist === null) {
      return "All";
    }
    return selectedArtist.stage_name;
  };

  return (
    <div className="bar-selector-container" ref={dropdownRef}>
      <button
        className="bar-selector-button"
        onClick={() => setIsOpen(!isOpen)}
        type="button"
      >
        <span className="bar-selector-text">
          {displayText()}
        </span>
        <span className={`bar-selector-arrow ${isOpen ? "open" : ""}`}>▼</span>
      </button>

      {isOpen && userArtists.length > 1 && (
        <div className="bar-selector-dropdown">
          {/* "All" option when multiple artists exist */}
          <button
            className={`bar-selector-option ${
              selectedArtist === null ? "selected" : ""
            }`}
            onClick={() => handleSelectArtist(null)}
            type="button"
          >
            <span className="bar-option-name">All</span>
            {selectedArtist === null && (
              <span className="bar-option-check">✓</span>
            )}
          </button>
          {/* Individual artist options */}
          {userArtists.map((artist) => (
            <button
              key={artist.artist_id}
              className={`bar-selector-option ${
                selectedArtist?.artist_id === artist.artist_id ? "selected" : ""
              }`}
              onClick={() => handleSelectArtist(artist)}
              type="button"
            >
              <span className="bar-option-name">{artist.stage_name}</span>
              {selectedArtist?.artist_id === artist.artist_id && (
                <span className="bar-option-check">✓</span>
              )}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ArtistSelector;
